import React, { Suspense } from 'react';
import './App.css';

// Import components
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/AppRoutes';
import Loading from './pages/Loading';

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <AuthProvider>
        <div className="App">
          <AppRoutes />
        </div>
      </AuthProvider>
    </Suspense>
  );
}

export default App;
